import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { formatNumber, formattedDate, formattedTime } from "@/lib/helper";
import { cn } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";
import { VscEye } from "react-icons/vsc";
import { Link } from "react-router";

import { Separator } from "@/components/ui/separator";
import { useCurrency } from "@/lib/useCurrency";
import { BookText, MoreHorizontal } from "lucide-react";
import TransactionActions from "./common/TransactionActions";
import UpdateTransaction from "./common/UpdateTransaction";
import { useState } from "react";
// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.

export type Transaction = {
  status: "successful" | "pending" | "failed";
  createdAt: string;
  userId: string;
  crypto: string;
  received: string;
  rate: string;
  paid: string;
  reference: string;
};
export const columns: ColumnDef<Transaction>[] = [
  {
    accessorKey: "createdAt",
    header: () => {
      return <div>Date</div>;
    },
    cell: ({ row }) => (
      <div className="flex flex-col">
        <span className="text-sm text-gray">
          {formattedDate(row.getValue("createdAt"))}
        </span>
        <span className="text-sm text-gray-0">
          {formattedTime(row.getValue("createdAt"))}
        </span>
      </div>
    ),
  },
  {
    accessorKey: "currency",
    header: () => {
      return <div>Currency</div>;
    },
    cell: ({ row }) => <div>{row?.getValue("currency")}</div>,
  },
  {
    accessorKey: "amount",
    header: () => {
      return <div>We received</div>;
    },
    cell: ({ row }) => {
      const { handleSelectCurrency } = useCurrency();
      // {row?.getValue("code") === 'BTC' ?
      // formatNumber(row?.getValue("pending"), row?.getValue("pending") === 0 ? 0 : 8)
      //  : formatNumber(row?.getValue("pending"), row?.getValue("pending") === 0 ? 0 : 2)} {row?.getValue("code")}

      //     row?.original?.currency === 'BTC' ? 8 : 0)
      //   {/* } ${row.original?.amount?.toLocaleString()}`} 
      //   formatNumber(row?.getValue("pending"),
      //    row?.getValue("balance") === 0 ? 0 : 8) : formatNumber(row?.getValue("pending"), 
      //   row?.getValue("pending") === 0 ? 0 : 2)} {row?.getValue("code")*/} 
      return (
        <div>
          {handleSelectCurrency(row?.getValue("currency"))?.type !== "fiat" &&
            row?.original?.type === "payin" &&
            `${row.original?.amount} ${row?.original?.currency}`}
          {handleSelectCurrency(row?.getValue("currency"))?.type === "fiat" &&
            row?.original?.type === "payin" &&
            `${row?.original?.currency
            } ${['BTC',"TRX","ETH","BNB","SOL"]?.includes(row?.original?.currency) ? formatNumber(row.original?.amount, row.original?.amount === 0 ? 0 : 8) : formatNumber(row.original?.amount, 2)}`}
          {row?.original?.type === "cross" &&
            `${row?.original?.currency
            }
            ${["BTC","TRX","ETH","BNB","SOL"]?.includes(row?.original?.currency) ? formatNumber(row.original?.amount, row.original?.amount === 0 ? 0 : 8) : formatNumber(row.original?.amount, 2)}`
          }
          {/* // ${row?.original?.amount?.toLocaleString()} */}

          {handleSelectCurrency(row?.getValue("currency"))?.type === "crypto" &&
            row?.original?.type === "payout" &&
            `0.00 ${row?.original?.currency}`}
          {handleSelectCurrency(row?.getValue("currency"))?.type === "fiat" &&
            row?.original?.type === "payout" &&
            `${row?.original?.currency} 0.00`}
        </div>
      );
    },
  },
  {
    accessorKey: "rate",
    header: () => <div className="capitalize">Exchange Rate</div>,
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue("rate"));

      const formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "NGN",
      }).format(amount);
      console.log(formatted, 'formatted');

      return (
        <>
          {row?.original?.type === "cross" ? (
            <p className="font-medium ">
              1 {row?.getValue("currency")} / {formatted === 'NGNNaN'?'N/A':formatted}
            </p>
          ) : (
            <div className="flex justify-center">
              <Separator className="w-4" />
            </div>
          )}
        </>
      );
    },
  },
  {
    accessorKey: "withdrawalAmount",
    header: () => <div className="capitalize">We Paid out</div>,
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue("withdrawalAmount"));
      // const amount = parseFloat(row.getValue("withdrawalAmount"));
      const currency = row?.original?.withdrawalCurrency;
      const { handleSelectCurrency } = useCurrency();
      // console.log(amount, 'scd');
      // console.log(row.getValue("withdrawalAmount"), 'withdraw');
      return (
        <div>
          {/* // ${row.original?.amount}  */}
          {handleSelectCurrency(row?.getValue("currency"))?.type !== "fiat" &&
            row?.original?.type === "payout" &&
            `
            ${currency === 'BTC' ? formatNumber(row.original?.amount, row.original?.amount === 0 ? 0 : 8) : formatNumber(row.original?.amount, 2)}
            ${row?.original?.currency}`}
          {handleSelectCurrency(row?.getValue("currency"))?.type === "fiat" &&
            row?.original?.type === "payout" &&
            `${row?.original?.currency} ${formatNumber(row.original?.amount, 2)}
            
            `}
          {/* // ${currency === 'BTC' ? formatNumber(amount, amount === 0 ? 0 : 8) : formatNumber(amount, 2)} */}
          {/* } ${row.original?.amount?.toLocaleString()}`} */}
          {row?.original?.type === "cross" &&
            `${currency} ${currency === 'BTC' ? formatNumber(amount, amount === 0 ? 0 : 8) : formatNumber(amount, 2)}
            `}
          {/* // ${amount?.toLocaleString()} */}

          {handleSelectCurrency(row?.getValue("currency"))?.type === "crypto" &&
            row?.original?.type === "payin" &&
            `0.00 ${row?.original?.currency}`}
          {handleSelectCurrency(row?.getValue("currency"))?.type === "fiat" &&
            row?.original?.type === "payin" &&
            `${row?.original?.currency} 0.00`}
        </div>
      );
    },
  },
  {
    accessorKey: "status",
    header: () => <div className="capitalize">General Status</div>,
    cell: ({ row }) => (
      <div
        className={cn(
          "flex justify-center items-center rounded-[4px]  py-1 w-fit px-8 capitalize",
          row.getValue("status") === "success"
            ? "bg-green-0 text-green-3"
            : row.getValue("status") === "pending"
              ? "bg-saffron-10 text-saffron"
              : "bg-error-0 text-error-2"
        )}
      >
        <p className="font-medium text-xs">{row.getValue("status")}</p>
      </div>
    ),
  },
  {
    accessorKey: "_status",
    header: () => <div className="capitalize">Platform Status</div>,
    cell: ({ row }) => (
      <div
        className={cn(
          "flex justify-center items-center rounded-[4px]  py-1 w-fit px-8 capitalize",
          row.getValue("_status") === "blocked" ||
            row.getValue("_status") === "failed" ||
            row.getValue("_status") === "cancelled"
            ? "bg-error-0 text-error-2"
            : row.getValue("_status") === "pending_withdrawal" ||
              row.getValue("_status") === "pending_swap" ||
              row.getValue("_status") === "pending_payin" ||
              row.getValue("_status") === "pending_settlement" ||
              row.getValue("_status") === "processing"
              ? "bg-saffron-10 text-saffron"
              : row?.getValue("_status") === "queued"
                ? "bg-blue-400 text-blue-700"
                : "bg-green-0 text-green-3"
        )}
      >
        <p className="font-medium text-xs">{row.getValue("_status")}</p>
      </div>
    ),
  },

  {
    id: "actions",
    enableHiding: false,
    cell: ({ row }) => {
      return (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem>
              <Link
                to={row?.original?.id}
                className="flex items-center gap-2 text-xs text-primary-9"
              >
                <VscEye className="text-primary-9" />
                View Transaction
              </Link>
            </DropdownMenuItem>
            {row.getValue("_status") === 'pending_settlement' &&
              <DropdownMenuItem
                asChild
              >

                <UpdateTransaction
                  data={row?.original}
                />
              </DropdownMenuItem>
            }
            <TransactionActions
              id={row.original.id}
              status={row.getValue("_status")}
            />
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
  },
];
